import React from "react";
import { ENABLE_TRACKING, GA_MEASUREMENT_ID, GTM_ID, URL } from "src/Config/appConfig";

const isEnquiry = window.location.pathname === URL.ENQUIRY;

class HelmetWrapper extends React.Component {
    public componentDidMount() {
        if (ENABLE_TRACKING) {
            const gtmId = isEnquiry ? GTM_ID.ENQUIRY : GTM_ID.PORTAL;
            const measurementId = isEnquiry ? GA_MEASUREMENT_ID.ENQUIRY : GA_MEASUREMENT_ID.PORTAL;
            const trackingWindow = window as Window & {
                dataLayer?: any[];
                gtag?: (command: string, value: string | Date) => void;
            };
            const dataLayer = trackingWindow.dataLayer = trackingWindow.dataLayer || [];
            // Run initialization from our bundle rather than CSP-blocked inline scripts.
            trackingWindow.gtag = function(command: string, value: string | Date) {
                dataLayer.push(arguments);
            };
            dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            trackingWindow.gtag("js", new Date());
            trackingWindow.gtag("config", measurementId);

            const script = document.createElement("script");
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
            document.head.appendChild(script);

            const analyticsScript = document.createElement("script");
            analyticsScript.async = true;
            analyticsScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
            document.head.appendChild(analyticsScript);
        }
    }

    public render() {
        const { children } = this.props;
        return (
            <>
                {children}
            </>
        );
    }
}

export default HelmetWrapper;



// WEBPACK FOOTER //
// ./src/Components/HelmetWrapper/HelmetWrapper.tsx